import React from "react";

import { RightOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import { PaginationLink } from "./PaginationLink";

export function PaginationNext({
    className,
    "aria-label": ariaLabel = "Go to next page",
    ...props
}: React.ComponentProps<typeof PaginationLink>) {
    return (
        <PaginationLink
            aria-label={ariaLabel}
            size="default"
            className={cx(className)}
            {...props}
        >
            <RightOutlined />
        </PaginationLink>
    );
}
